<template>
  <div>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Tag Name</label>
              <vs-input type="text" v-model="filters['name']" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Categories</label>
              <v-select :clearable="true" name="status" placeholder="" v-model="filters['category_ids']" label="name"
                :options="category_list" :reduce="option => option.id" multiple />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
      </vx-card>
      <vx-card >
        <template slot="actions">
            <vs-button @click="onClickCreateTag" class="mr-4" color="primary" type="filled">Create</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-table v-can="'view-user-role'" :max-items="(meta.per_page) ? meta.per_page : 10" @sort="handleSort" :sst="true" :data="invoices" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>TAG STATUS</vs-th>
              <vs-th>TAG CATEGORY</vs-th>
              <vs-th>ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="cursor-pointer" @click.native="onClickUserView(data[index].id)"  :key="index" v-for="(tr, index) in invoices">

                <vs-td :data="data[index].name">
                  {{ data[index].name }}
                </vs-td>
                <vs-td :data="data[index].status">
                  {{ data[index].status.name}}
                </vs-td>
                <vs-td>
                  {{ data[index].category ? data[index].category.name : 'N/A' }}
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip text="View/Update" class="ml-5">
                      <vs-button @click.stop="onClickUserView(data[index].id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 1" v-model="page"  class="p-5"></vs-pagination>
        </div>
      </vx-card>
    </div>
  </div>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import Filter from '@/mixins/filter';
import ErrorMessages from "@/mixins/ErrorMessages";
import vSelect from 'vue-select'
const HelpTagRepository = RepositoryFactory.get('helpTag')

export default {
  name: "TenantInvoice",
  data () {
    return {
      invoices: [],
      meta:{},
      page : 1,
      sort: '',
      filters: {},
      category_list: []
    }
  },
  mixins:[ErrorMessages, Filter],
  components: {
    'v-select': vSelect,
  },
  mounted() {
    this.loadInvoiceList()
    this.fetchHelpTagCategories()
  },
  methods:{
    async loadInvoiceList() {
      this.$vs.loading()
      try {
        const { data } = await HelpTagRepository.get(this.page, 20, this.filterQuery)
        this.invoices = data.data;
        this.meta.last_page = data.last_page
      } catch(e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadInvoiceList()
      }

    },
    onClickUserView(id){
      this.$router.push(`/pages/help-tags/${id}`)
    },
    handleChangePage(page) {
      this.page=page;
      this.loadInvoiceList()
    },
    onClickCreateTag() {
      this.$router.push('/pages/help-tags/create')
    },
    filterQueryUpdate (){
      this.loadInvoiceList()
    },
    async fetchHelpTagCategories() {
      try {
        const { data } = (await HelpTagRepository.getTagCategories(1, 150)).data
        this.category_list = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
  },
  watch : {
    page(){
      this.loadInvoiceList()
    }
  },
}
</script>

<style scoped>

</style>
